import type { TFunction } from 'i18next';
import { createContext, useContext } from 'react';

import { LanguageCode } from '@/modules/common/types';

interface LanguageContextInterface {
  language: LanguageCode;
  setLanguage: (language: LanguageCode) => Promise<TFunction> | undefined;
}

const initialContext: LanguageContextInterface = {
  language: LanguageCode.EN,
  setLanguage: () => undefined,
};

export const LanguageContext = createContext<LanguageContextInterface>(initialContext);
export const useLanguage = () => useContext(LanguageContext);
